import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ec35eaaa&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec35eaaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec35eaaa')) {
      api.createRecord('ec35eaaa', component.options)
    } else {
      api.reload('ec35eaaa', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ec35eaaa&scoped=true&", function () {
      api.rerender('ec35eaaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EhEEoaFEE9US/JS/comp/Accordion.vue"
export default component.exports